/** Пользователи эскизного отдела с доступом к разделам ЭП */
export const SKETCH_DESIGN_USER_IDS = [94, 96, 98, 99];

export const getLevelName = (level) =>
  typeof level === "string" ? level : level?.name;

const hasAnyLevel = (userData, allowedLevels) =>
  userData?.access_levels?.some((level) =>
    allowedLevels.includes(getLevelName(level))
  );

export const hasAccessToOvertimeApproval = (userData) =>
  hasAnyLevel(userData, ["АДМС", "РО", "НО", "РГ", "ГИП", "ИК"]);

export const hasAccessToTimesheetApproval = (userData) =>
  hasAnyLevel(userData, ["АДМС"]) ||
  userData?.id === 275 ||
  userData?.id === 131;

export const hasAccessToSalaryApproval = (userData) =>
  hasAnyLevel(userData, ["АДМС", "РО"]) || userData?.id === 275;

/** Согласование проекта: смета и соглашения. Всем авторизованным — API отдаёт только свои назначения. */
export const hasAccessToProjectApproval = (userData) => Boolean(userData);

/** Согласование проектов ЭП и выплат ЭП */
export const hasAccessToEpApproval = (userData) =>
  hasAnyLevel(userData, ["АДМС", "ФИН", "РО", "НО"]) ||
  SKETCH_DESIGN_USER_IDS.includes(userData?.id);

export const hasAccessToApprovals = (userData) =>
  hasAccessToOvertimeApproval(userData) ||
  hasAccessToTimesheetApproval(userData) ||
  hasAccessToSalaryApproval(userData) ||
  hasAccessToProjectApproval(userData) ||
  hasAccessToEpApproval(userData);
